import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      quote: "This webinar changed my perspective on client retention. Highly recommended!",
      name: "Aditi",
      title: "Salon Owner"
    },
    {
      quote: "The strategies shared are simple yet powerful. My revenue has doubled in three months.",
      name: "Rahul", 
      title: "Spa Manager"
    },
    {
      quote: "AI automation has saved me 25 hours per week. I can finally focus on growing my business instead of managing it.",
      name: "Rajiv",
      title: "Salon Owner"
    },
    {
      quote: "I loved the practical examples and tools provided. They made execution so much easier.",
      name: "Priya",
      title: "Beauty Studio Owner"
    },
    {
      quote: "Zylu's calculators and scorecards are game-changers. My team and I use them daily.",
      name: "Karan",
      title: "Salon Franchise Manager"
    },
    {
      quote: "Insightful, engaging, and packed with actionable advice. I've already started seeing results.",
      name: "Anjali",
      title: "Hair Salon Owner"
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-8 md:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-black">
            Testimonials
          </h2>
          <div className="w-24 h-1 bg-red-500 mx-auto mb-8"></div>
          <p className="text-base sm:text-lg md:text-xl text-gray-600">
            Hear from salon and spa owners who have transformed their businesses
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50, rotateY: -20 }}
              whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
              transition={{ 
                duration: 0.8, 
                delay: index * 0.15,
                type: "spring",
                stiffness: 90
              }}
              whileHover={{ 
                scale: 1.05, 
                y: -8,
                rotateY: 5,
                boxShadow: "0 15px 35px rgba(239, 68, 68, 0.25)"
              }}
              viewport={{ once: true }}
              className="p-4 md:p-8 rounded-lg shadow-lg flex flex-col items-center text-center hover:shadow-red-500/20 transition-all duration-300 transform border border-gray-200"
              style={{ backgroundColor: '#f8f9fa' }}
            >
              {/* 5 Star Rating */}
              <div className="flex text-yellow-500 mb-3 md:mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} fill="currentColor" className="h-4 w-4 md:h-5 md:w-5" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 text-sm sm:text-base md:text-lg italic mb-4 md:mb-6 leading-relaxed">
                "{testimonial.quote}"
              </p>

              {/* Name and Title */}
              <div>
                <p className="font-semibold text-red-600 text-base md:text-lg">{testimonial.name}</p>
                <p className="text-gray-500 text-xs md:text-sm">{testimonial.title}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
